/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {uploadFile} from '../api'

export const useMutationUploadFile = createReactQueryMutationHook('uploadFile', uploadFile)
